import { Col, Form, Label, Row } from "reactstrap"
import {
  DebounceInputSearch,
  UFDate,
  UFInput,
} from "../../../components/Common/Fields/Input"
import resetIcon from "../../../assets/icons/reset.svg"
import { useForm } from "react-hook-form"
import { useEffect } from "react"
import moment from "moment"
import { isEmpty } from "lodash"
import VoucherTypes from "../../../components/Common/chooseFields/voucherTypes"

const JournalEntryFilter = ({
  handleSearchChange,
  handleDateChange,
  handleAccChange,
  handleVoucherTypeChange,
  resetData,
}) => {
  const { dateFrom, dateTo } = resetData || {}
  const { control, watch, reset, setValue } = useForm()
  const handleReset = () => {
    handleDateChange()
    handleSearchChange()
    handleAccChange()
    handleVoucherTypeChange()
    reset({
      search: "",
      account_code: null,
      start_date: "",
      end_date: "",
      voucher_type: null,
    })
  }
  console.log(`resetData`, resetData)

  useEffect(() => {
    handleSearchChange(watch("search"))
  }, [watch("search")])

  const handleRequestdate = () => {
    const startDate = watch("start_date")
    const endDate = watch("end_date")
    const formattedStart = startDate
      ? moment(startDate).format("YYYY-MM-DD")
      : ""
    const formattedEnd = endDate ? moment(endDate).format("YYYY-MM-DD") : ""
    handleDateChange(formattedStart, formattedEnd)
  }

  const handleAccno = data => {
    handleAccChange(data?.value)
  }

  const handleVoucherType = data => {
    handleVoucherTypeChange(data?.value)
  }

  useEffect(() => {
    setValue(
      "start_date",
      dateFrom ? moment(dateFrom, "YYYY-MM-DD").toDate() : null,
      { shouldValidate: false, shouldDirty: false }
    )
    setValue(
      "end_date",
      dateTo ? moment(dateTo, "YYYY-MM-DD").toDate() : null,
      { shouldValidate: false, shouldDirty: false }
    )
  }, [dateFrom, dateTo, setValue])

  return (
    <>
      <div className="d-flex justify-content-between align-items-center my-2 me-2">
        <Form id="user-form" className="filter-wrapper">
          <Row className="mx-0">
            {/* <Col sm={2} className="pe-1">
              <AccountsLi
                control={control}
                name={"account_code"}
                placeholder={"Acc-Code"}
                target={"body"}
                fromFilter={true}
                onSelectChange={e => handleAccno(e)}
              />
            </Col> */}
            <Col sm={2} className="pe-1">
              <UFDate
                control={control}
                name={"start_date"}
                placeholder={"Start Date"}
                onDateChange={handleRequestdate}
              />
            </Col>
            <Col sm={2} className="pe-1">
              <UFDate
                control={control}
                name={"end_date"}
                placeholder={"End Date"}
                onDateChange={handleRequestdate}
              />
            </Col>
            {/* <Col sm={2} className="pe-1">
              <VoucherTypes
                control={control}
                name={"voucher_type"}
                placeholder={"Voucher Type"}
                onSelectChange={e => handleVoucherType(e)}
                clearable={true}
              />
            </Col> */}
          </Row>
        </Form>
        <div className="d-flex">
          {/* <Col
            lg={"auto"}
            onClick={() => handleFinacialCheck(finacialCheck)}
            className=" d-flex align-items-center"
          >
            <input
              type="checkbox"
              className="ever-rise-checkbox"
              name={"is_finacial_year"}
              checked={finacialCheck}
            />
            <Label className="ms-2 mb-0">
              FY {loggedUser?.finance?.replace(/\//g, "")}
            </Label>
          </Col> */}
          {/* <div
            className="export-div pointer me-2 reset-img"
            onClick={() => handleReset()}
          >
            <img src={resetIcon} height={15} width={15} className="me-2" />{" "}
            Reset
          </div> */}
          <DebounceInputSearch
            control={control}
            placeholder={"Search"}
            name={"search"}
            className={"search-input"}
            minLength={1}
            debounceTimeout={700}
          />
          {/* <UFInput
            control={control}
            placeholder="Search"
            name={"search"}
            className={"search-input"}
          /> */}
          {/* <div className="export-div pointer" onClick={() => toggle()}>
            <img src={exportIcon} />
          </div> */}
        </div>
      </div>
    </>
  )
}

export default JournalEntryFilter
